import { HostProfileDTO } from "../host-dtos/host-profile.dto";
import { AmbassadorDTO } from "./ambassador.dto";
import { AttendeeDTO } from "./attendee.dto";
import { UserDTO } from "./user.dto";

export class UserDetailDTO {
    isFavoriteHost: boolean = false;
    user: UserDTO = new UserDTO();
    profiles: ProfilesDTO = new ProfilesDTO();

    constructor(data: Partial<UserDetailDTO> = {}) {
        for (let key in data) {
            if (key === 'user') {
                this[key] = new UserDTO(data[key] ?? {});
            } else if (key === 'profiles') {
                this[key] = new ProfilesDTO(data[key] ?? {});
            } else {
                this[key] = data[key];
            }
        }
    }
}

class ProfilesDTO {
    host: HostProfileDTO = new HostProfileDTO();
    attendee: AttendeeDTO = new AttendeeDTO();
    ambassador: AmbassadorDTO = new AmbassadorDTO();

    constructor(data: Partial<ProfilesDTO> = {}) {
        for (let key in data) {
            if (key === 'host') {
                this[key] = new HostProfileDTO(data[key]);
            } else if (key === 'attendee') {
                this[key] = new AttendeeDTO(data[key]);
            } else if (key === 'ambassador') {
                this[key] = new AmbassadorDTO(data[key]);
            }
        }
    }
}